import { mpBackend } from '../../config/axios';
import { TUserRoles } from '../context/user/user.type';
import { userTransformer } from '../context/user/utils/user.transformer';

export interface IAuthUser {
  isLoggedIn: boolean;
  externalId: string;
  username: string;
  role: TUserRoles;
}
export const getAuthenticationStatus = (
  cookie: string | undefined
): Promise<IAuthUser> => {
  return mpBackend
    .get('user/isAuthenticated', {
      headers: {
        Cookie: cookie,
      },
    })
    .then((data) => {
      return userTransformer({ ...data.response, isLoggedIn: true });
    })
    .catch(() => {
      return userTransformer({});
    });
};
